import dayjs from 'dayjs';

export const isDateToday = (date) => dayjs(date).diff(new Date(), 'days', true) <= 0;

export const filterTimesAfterNow = (list) => list.filter((t) => dayjs(dayjs(), 'HH:mm:ss').isSameOrBefore(dayjs(t.end, 'HH:mm:ss')));

export function isSameDay({ date1, date2 }) {
  return date1.getFullYear() === date2.getFullYear() &&
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth();
}

/**
 * Format an API hour string (e.g. "08:00:00", "08:00", "8:00") as a 12-hour
 * clock label for the admin UI. Uses a fixed epoch date to avoid any DST
 * shift that would occur if we mutated today's date via dayjs().hour(...).
 */
export function formatClock12(hourStr) {
  if (hourStr == null || hourStr === '') return '';
  const normalized = String(hourStr).trim();
  const d = dayjs(`1970-01-01T${normalized.length <= 5 ? `${normalized}:00` : normalized}`);
  if (!d.isValid()) return normalized;
  return d.format('h:mm A');
}

export const formatTime = ({ fromHour, duration }) => {
  if (!duration) {
    return formatClock12(fromHour);
  }
  return dayjs(fromHour, 'HH:mm:ss')
    .add(dayjs.duration(duration).hours(), 'hours')
    .format('h:mm A');
};

export function formatLastModified(updatedAt) {
  if (!updatedAt) return '-';
  const d = new Date(updatedAt);
  const now = new Date();
  const diffDays = Math.floor((now - d) / (1000 * 60 * 60 * 24));
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return '1 day ago';
  if (diffDays < 7) return `${diffDays} days ago`;
  return d.toLocaleDateString();
}
